'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.timestampIsTomorrow = undefined;

var _I18n = require('I18n');

var _I18n2 = _interopRequireDefault(_I18n);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TWENTY_FOUR_HOURS_IN_MS = 24 * 60 * 60 * 1000;

var timestampIsTomorrow = exports.timestampIsTomorrow = function timestampIsTomorrow(timestamp) {
  var tomorrow = _I18n2.default.moment(Date.now() + TWENTY_FOUR_HOURS_IN_MS);

  return tomorrow.isSame(_I18n2.default.moment(timestamp), 'd');
};


//////////////////
// WEBPACK FOOTER
// ./js/availability/util/timestampIsTomorrow.js
// module id = 387
// module chunks = 2 3